export const TABS = [
  { label: 'users', value: '0' },
  { label: 'country', value: '1' },
  { label: 'state', value: '2' },
  { label: 'school', value: '3' },
  { label: 'trainingReason', value: '4' }
];
